module.exports = __webpack_public_path__ + "img/portrait-avatar-before.6a1a799e.jpg";